var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Tooltip } from '@hn-ui/tooltips';
import { styled } from 'styled-components';
import { EditButton } from '../Buttons';
import { classLinkText, cleverText } from '../Common';
import { SUPPORT_EMAIL_ADDRESS } from '../../Common/constants/links';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1f64ecf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  margin-bottom: 8px;\n"], ["\n  display: flex;\n\n  margin-bottom: 8px;\n"])));
var Grade = styled.span.withConfig({ displayName: "Grade", componentId: "sc-rys54" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 16px;\n\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  margin-right: 16px;\n\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var EmailLink = styled.a.withConfig({ displayName: "EmailLink", componentId: "sc-1yuj692" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n"], ["\n  color: ", ";\n  text-decoration: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
export var ManualText = function () { return (_jsxs(_Fragment, { children: ["If you want to change your grade for the whole class, please send a request with your class number and a grade that needs to be changed to\u00A0", _jsx(EmailLink, __assign({ href: "mailto: " + SUPPORT_EMAIL_ADDRESS }, { children: SUPPORT_EMAIL_ADDRESS }), void 0), "."] }, void 0)); };
var tooltipText = {
    clever: cleverText,
    classLink: classLinkText,
};
var EditButtonContainer = styled.span.withConfig({ displayName: "EditButtonContainer", componentId: "sc-1jhwx9r" })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var GradeUnit = function (_a) {
    var type = _a.type, grade = _a.grade;
    return (_jsxs(Container, { children: [_jsx(Grade, { children: "Grade: " + grade }, void 0), _jsx(Tooltip, __assign({ content: type === 'manual' ? _jsx(ManualText, {}, void 0) : tooltipText[type], maxWidth: 386 }, { children: _jsx(EditButtonContainer, { children: _jsx(EditButton, { disabled: true }, void 0) }, void 0) }), void 0)] }, void 0));
};
export { GradeUnit };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
